'use client'

import { getSchemaConstraints } from '@/components/forms/helpers/schema-constraints'
import { communityCreationSchema } from '@/components/forms/schemas/community'
import { Button } from '@/components/ui/button'
import getUserName from '@/helpers/get-user-name'
import { cn } from '@/lib/utils'
import LanguageField from './fields/language-field'
import NameField from './fields/name-field'

export default function NameLanguageForm({
  user,
  form,
  formStep,
  nextButtonClick,
}) {
  // Get the current name value and any errors from the form state
  const nameValue = form.watch('name')

  const nameConstraints = getSchemaConstraints(communityCreationSchema, 'name')

  const nameIsValid =
    nameValue &&
    nameValue.length >= nameConstraints.min &&
    nameValue.length <= nameConstraints.max

  const handleNextClick = () => {
    if (nameIsValid) {
      nextButtonClick()
    }
  }

  return (
    <div
      className={cn('flex h-full w-full flex-col justify-center gap-5 pb-6', {
        hidden: formStep !== 0,
      })}
    >
      <div className="flex h-full flex-col gap-4">
        {user && (
          <p className="mb-5 text-p-1 font-medium text-neutral-blue-200">
            Welcome, {getUserName(user)}. <br></br>
            Let's create your Community
          </p>
        )}
        <NameField form={form} onEnterPress={handleNextClick} />
        <LanguageField form={form}></LanguageField>
      </div>

      <Button
        type="button"
        onClick={nextButtonClick}
        className="md:me-auto"
        disabled={!nameIsValid}
      >
        Next
      </Button>
    </div>
  )
}
